<template>
  <usertables
    :section="'news'"
    :title="'News'"
  >
  </usertables>
</template>

<script>
  import Usertables from './userTables'
  export default {
    name: 'News',
    components: {Usertables}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user-class/news.vue